var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6410_179018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 2.99999H5.1C3.83988 2.99999 3.20982 2.99999 2.72852 3.24522C2.30516 3.46094 1.96095 3.80514 1.74524 4.22851C1.5 4.70981 1.5 5.33987 1.5 6.59999V12.9C1.5 14.1601 1.5 14.7902 1.74524 15.2715C1.96095 15.6948 2.30516 16.039 2.72852 16.2548C3.20982 16.5 3.83988 16.5 5.1 16.5H11.4C12.6601 16.5 13.2902 16.5 13.7715 16.2548C14.1948 16.039 14.539 15.6948 14.7548 15.2715C15 14.7902 15 14.1601 15 12.9V9.74999M5.99998 12H7.25589C7.62277 12 7.80622 12 7.97885 11.9585C8.1319 11.9218 8.27822 11.8612 8.41243 11.7789C8.5638 11.6862 8.69352 11.5565 8.95294 11.297L16.125 4.12499C16.7463 3.50367 16.7463 2.49631 16.125 1.87499C15.5037 1.25367 14.4963 1.25367 13.875 1.87499L6.70293 9.04704C6.4435 9.30647 6.31378 9.43619 6.22102 9.58756C6.13878 9.72177 6.07817 9.86809 6.04143 10.0211C5.99998 10.1938 5.99998 10.3772 5.99998 10.7441V12Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6410_179018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.8a69ae48ac6e055346fbdd7266d5bcbe.svg";
export { ForwardRef as ReactComponent };